/*
 *
 * custom components
 *
 * start
 *
 */

import ConsoleService from './consoleServiceModules/ConsoleService';

import ConsoleServiceIndexedDbModuleRecipientComponent from "./consoleServiceModules/ConsoleServiceIndexedDbModuleRecipientComponent";

import { indexed_db_name, indexed_db_version } from './../IndexedDbComponent';

/*
 *
 * custom components
 *
 * stop
 *
 */

const execute = (payload) => {

    let flag_console_log = ConsoleServiceIndexedDbModuleRecipientComponent;

    ConsoleService('', flag_console_log);
    ConsoleService('IndexedDbRecipientUpdateComponent', flag_console_log);

    ConsoleService('IndexedDbRecipientUpdateComponent / payload', flag_console_log);
    ConsoleService(payload, flag_console_log);

    let idb_name = indexed_db_name;

    ConsoleService('IndexedDbRecipientUpdateComponent / IndexedDb / idb name', flag_console_log);
    ConsoleService(idb_name, flag_console_log);

    let version = indexed_db_version;

    ConsoleService('IndexedDbRecipientUpdateComponent / IndexedDb / version', flag_console_log);
    ConsoleService(version, flag_console_log);

    return new Promise(
        (resolve, reject) => {

            ConsoleService('IndexedDbRecipientUpdateComponent / new promise', flag_console_log);

            let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            /*
             *
             * request
             *
             * start
             * 
             */

            let request = indexedDB.open(idb_name, version);

            /*
             * request / on success / callback
             *
             * start
             * 
             */

            request.onsuccess = function (event) {

                ConsoleService('IndexedDbRecipientUpdateComponent / request / on success', flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                let db = event.target.result;

                /*
                 *
                 * transaction
                 *
                 * start
                 * 
                 */

                /*
                 *
                 * transaction
                 * 
                 * open a read/write db transaction, ready for adding the data
                 * 
                 * https://developer.mozilla.org/en-US/docs/Web/API/IDBDatabase/transaction
                 * 
                 */

                let transaction = db.transaction(['recipient_object_store'], 'readwrite');

                ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / transaction', flag_console_log);
                ConsoleService(transaction, flag_console_log);

                /*
                 * report on the success of opening the transaction
                 */

                transaction.oncomplete = function (event) {

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / transaction / on complete', flag_console_log);

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / transaction / on complete / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    resolve(event);

                }

                transaction.onerror = function (event) {

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / transaction / on error', flag_console_log);

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / transaction / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * transaction
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store
                 *
                 * start
                 * 
                 */

                let objectStore = transaction.objectStore('recipient_object_store');

                ConsoleService('store', flag_console_log);
                ConsoleService(objectStore, flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / objectStore.indexNames', flag_console_log);
                ConsoleService(objectStore.indexNames, flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / objectStore.keyPath', flag_console_log);
                ConsoleService(objectStore.keyPath, flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / objectStore.name', flag_console_log);
                ConsoleService(objectStore.name, flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / objectStore.transaction', flag_console_log);
                ConsoleService(objectStore.transaction, flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / objectStore.autoIncrement', flag_console_log);
                ConsoleService(objectStore.autoIncrement, flag_console_log);

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * start
                 * 
                 */

                let objectStoreRequest = objectStore.put(payload);

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onsuccess = function (event) {

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / objectStoreRequest / on success', flag_console_log);

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / objectStoreRequest / on success / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    //resolve(event);

                }

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onerror = function (event) {

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / objectStoreRequest / on error', flag_console_log);

                    ConsoleService('IndexedDbRecipientUpdateComponent / request / on success / objectStoreRequest / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * stop
                 * 
                 */

            }

            /*
             * request / on success / callback
             *
             * stop
             * 
             */

            /*
             * request / on error / callback
             *
             * start
             * 
             */

            request.onerror = function (event) {

                ConsoleService('IndexedDbRecipientUpdateComponent / request / on error', flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / request / on error / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                reject(event);

            }

            /*
             * request / on error / callback
             *
             * stop
             * 
             */

        }).then(
            (data) => {

                ConsoleService('IndexedDbRecipientUpdateComponent / new promise => then', flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / new promise => then / data', flag_console_log);
                ConsoleService(data, flag_console_log);

                return data;

            }
        ).catch(
            (data) => {

                ConsoleService('IndexedDbRecipientUpdateComponent / new promise => catch', flag_console_log);

                ConsoleService('IndexedDbRecipientUpdateComponent / new promise => catch / data', flag_console_log);
                ConsoleService(data, flag_console_log);

                return data;

            }
        );

    //

}

export default execute;